import { render, staticRenderFns } from "./GenCustomObjList.vue?vue&type=template&id=3d7a5635&scoped=true"
var script = {}
import style0 from "./GenCustomObjList.vue?vue&type=style&index=0&id=3d7a5635&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7a5635",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d7a5635')) {
      api.createRecord('3d7a5635', component.options)
    } else {
      api.reload('3d7a5635', component.options)
    }
    module.hot.accept("./GenCustomObjList.vue?vue&type=template&id=3d7a5635&scoped=true", function () {
      api.rerender('3d7a5635', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/gen/GenCustomObjList.vue"
export default component.exports